import AppBar from './components/AppBar';
import Footer from './components/Footer';

import './styles/Common.css';
import renderHTML from 'react-render-html';
import termsHTML from './html/terms_and_conditions';
import JumboContainer from './components/common/JumboContainer';

function TermsAndConditions() {
  return (
    <>
      <AppBar alwaysSolid />
      <JumboContainer white>
        {renderHTML(termsHTML)}
      </JumboContainer>
      <Footer/>
    </>
  );
}

export default TermsAndConditions;
